import React from 'react';
import { Document } from 'react-pdf/dist/esm/entry.webpack5';
import { PDFViewerDocumentProps } from '../types';

export const PDFViewerDocument = ({
	file,
	onLoadSuccess,
	loading,
	children,
}: PDFViewerDocumentProps) => {
	const onDocumentLoadSuccess = pdfDocument => {
		const promises = Array.from({ length: pdfDocument.numPages }, (_, i) => i + 1).map(
			pageNumber => {
				return pdfDocument.getPage(pageNumber);
			}
		);

		let scale: number | null = null;
		let previousAspectRatio;
		let hasDifferentPageSizes = false;

		Promise.all(promises).then(pages => {
			const map = new Map<number, number>();

			for (const page of pages) {
				const w = page.view[2] || 0;
				const h = page.view[3] || 0;
				const index = page.pageNumber ?? 0;
				const heightByWidthRatio = h / w;
				const widthByHeightRatio = w / h;

				// if rotate is odd multiple of 90 degree use widthByHeightRatio else use heightByWidthRatio
				const ratio =
					page.rotate / 90 / 2 === 0 ? heightByWidthRatio : widthByHeightRatio;
				map.set(index, ratio);

				if (!previousAspectRatio) {
					previousAspectRatio = ratio;
				}
				if (ratio !== previousAspectRatio) {
					hasDifferentPageSizes = true;
				}

				scale = Math.max(ratio, scale!);
			}

			onLoadSuccess({
				hasDifferentPageSizes,
				scale,
				pageAspectRatioMap: map,
				totalPages: pdfDocument?.numPages,
			});
		});
	};

	if (!file) {
		return loading;
	}

	return (
		<Document
			file={file}
			onLoadSuccess={onDocumentLoadSuccess}
			renderMode="canvas"
			options={{ disableAutoFetch: true, disableStream: true }}
			loading={loading}
			data-testid="pdf-document"
		>
			{children}
		</Document>
	);
};
